import type { CreditTierSE } from '@/api/credit/types';

export const selectCreditTierByAmount = (amount: number) => (creditTiers: CreditTierSE[]) =>
  creditTiers.find(tier => tier.amount === amount);

export const selectMaxCreditTier = (creditTiers: CreditTierSE[]) =>
  creditTiers.length > 0
    ? creditTiers.reduce((maxTier, tier) => (tier.amount > maxTier.amount ? tier : maxTier), creditTiers[0])
    : undefined;
